import { useState } from 'react'
import { MessageCircle, X, Send } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { gtmEvents } from '@/lib/gtm'

export const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [hasOpened, setHasOpened] = useState(false)

  const toggleChat = () => {
    const newState = !isOpen
    setIsOpen(newState)
    if (newState && !hasOpened) {
      gtmEvents.custom('chat_open')
      setHasOpened(true)
    }
  }

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault()
    if (!message.trim()) return

    gtmEvents.custom('chat_send_message', { message_length: message.length })
    setMessage('')
    // Simulate fake interaction
    setTimeout(() => {
      // Just clear input for demo
    }, 500)
  }

  return (
    <div className="fixed bottom-24 right-6 z-40 flex flex-col items-end">
      {isOpen && (
        <div className="bg-white border rounded-lg shadow-xl w-72 h-80 mb-4 flex flex-col overflow-hidden animate-in slide-in-from-bottom-5">
          <div className="bg-primary text-primary-foreground p-3 flex justify-between items-center">
            <span className="font-semibold text-sm">Suporte DP6.shop</span>
            <button onClick={toggleChat}>
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="flex-1 p-4 bg-slate-50 overflow-y-auto">
            <div className="bg-white p-2 rounded-lg shadow-sm text-sm inline-block max-w-[85%]">
              Olá! Como posso ajudar com sua implementação de GTM hoje?
            </div>
          </div>
          <form
            onSubmit={handleSend}
            className="p-3 border-t bg-white flex gap-2"
          >
            <Input
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Digite..."
              className="h-8 text-sm"
            />
            <Button size="sm" type="submit" className="h-8 w-8 p-0">
              <Send className="h-4 w-4" />
            </Button>
          </form>
        </div>
      )}

      <Button
        onClick={toggleChat}
        size="icon"
        className="rounded-full h-12 w-12 shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground"
      >
        <MessageCircle className="h-6 w-6" />
      </Button>
    </div>
  )
}
